import { useEffect, useState } from "react";
import { FooterForm, FeaturedSectors, StartupGaining, TestimonialCarousel, Presenters } from "../components/index";
import { tracking } from '../utils/tracking';
import { imgs } from '../assets/imgs';
import { useResizeImg } from '../hooks/useResizeImg';
import video from "../assets/videos/backgroundvideo3.mp4";
import { updateTags } from "../utils/funcs";


export const Startups = () => {
   const [isLoading, setIsLoading] = useState(true);

   useEffect(() => {
      updateTags("Venture Summit West | Startups")
   }, [])

   return (
      <div className='startups'>
         {/* <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section >
               <h1>Present</h1>
               <h2>Get Noticed. Get Funded. Grow Faster</h2>
            </section>
            <section>
               <a className="btn" href='https://account.youngstartup.com' onClick={() => { tracking(283); }}>APPLY NOW</a>
            </section>
         </Banner> */}
         <div className='banner video'>
            {isLoading &&
               <div className='shimmer-wrapper'>
                  <div className='shimmer'>
                     <video style={{ visibility: 'hidden' }} preload={'auto'} onLoadedData={() => setIsLoading(false)}>
                        <source src={video} type='video/mp4' />
                     </video>
                  </div>
               </div>}
            {!isLoading &&
               <video autoPlay loop muted>
                  <source src={video} type='video/mp4' />
               </video>}
            <div className='items-on-banner'>
               <section >
                  <h1>Present</h1>
                  <h2>Get Noticed. Get Funded. Grow Faster</h2>
               </section>
               <section>
                  {/* <a className="btn" href='https://account.youngstartup.com' onClick={() => { tracking(283); }}>APPLY NOW</a> */}
               </section>
            </div>
         </div>
         <FeaturedSectors />
         <StartupGaining />
         <TestimonialCarousel pageName={"startups;"} />
         {/* <Presenters /> */}
         <FooterForm />
      </div >
   );
};
